import React, { useState } from "react";
import { FaCode, FaServer, FaMobileAlt } from "react-icons/fa";
import { Box } from "@mui/material";

const ServicesSection = () => {
  const servicesData = [
    {
      title: "Web Development",
      icon: <FaCode />,
      skills: ["Laravel", "CakePHP", "CodeIgniter", "WordPress", "Drupal", "Joomla"],
    },
    {
      title: "Full Stack Development",
      icon: <FaServer />,
      skills: ["AngularJS", "NodeJS", "ReactJS", "Python", "RoR", "Java"],
    },
    {
      title: "Mobile App Development",
      icon: <FaMobileAlt />,
      skills: ["Android", "iOS", "React Native", "Flutter", "Wearable", "PWA"],
    },
  ];

  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <Box sx={{ background: "radial-gradient(circle, #1F6788,#161623)",width: "100%", padding: "40px 0" }}>
    <div>
      <h2 style={styles.heading}>Our Web & App Development Services Will Help You Thrive</h2>
      <p style={styles.subText}>
        Our cutting-edge, technology-driven web and mobile app development services will help your business build revenue and thrive.
      </p>

      <div style={styles.servicesWrapper}>
        {servicesData.map((service, index) => (
          <div
            key={index}
            style={{
              ...styles.serviceBox,
              backgroundColor: hoverIndex === index ? "#B0E0E6" : "white",
              color: hoverIndex === index ? "red" : "black",
            }}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <div style={styles.iconTitleWrapper}>
              <span
                style={{
                  fontSize: "2.5rem",
                  transition: "color 0.3s ease",
                  color: hoverIndex === index ? "black" : "#6A7FB5",
                }}
              >
                {service.icon}
              </span>
              <h3 style={styles.serviceTitle}>{service.title}</h3>
            </div>

            <div style={styles.skillsWrapper}>
              {service.skills.map((skill, skillIndex) => (
                <button
                  key={skillIndex}
                  style={{
                    ...styles.skillButton,
                    backgroundColor: hoverIndex === index ? "#f0f0f0" : "#e0e0e0",
                    color: hoverIndex === index ? "black" : "black",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "red";
                    e.currentTarget.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = hoverIndex === index ? "#f0f0f0" : "#e0e0e0";
                    e.currentTarget.style.color = "black";
                  }}
                >
                  {skill}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
    </Box>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "60px 20px",
    maxWidth: "1400px",
    margin: "auto",
    background: "radial-gradient(circle, #1F6788,#161623)",
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "-30px",
    textAlign: "center",
    padding: "60px 20px",
    maxWidth: "1400px",
    margin: "auto",
    color:"white"
  },
  subText: {
    fontSize: "1.2rem",
    marginBottom: "60px",
    textAlign: "center",
    color:"white",
    marginTop:"-5",
    
  },
  servicesWrapper: {
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    flexWrap: "wrap", // Now allows stacking on small screens
  },
  serviceBox: {
    width: "350px",
    padding: "25px",
    borderRadius: "10px",
   // border: "2px solid #6A7FB5",
   //background: "radial-gradient(circle, #1F6788,#161623)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    textAlign: "center",
    flex: "1 1 300px", // Ensures wrapping for mobile screens
    maxWidth: "350px", // Limits size on desktop
    boxShadow: `
    0px 12px 25px rgba(0, 0, 0, 0.6),  
    inset 0px 10px 20px rgba(255, 255, 255, 0.15),
    inset 0px -10px 30px rgba(0, 0, 0, 0.7),
    inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
    inset -10px 0px 20px rgba(255, 255, 255, 0.2)
  `,
  },
  iconTitleWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "15px",
  },
  serviceTitle: {
    fontSize: "1.7rem",
    fontWeight: "bold",
    marginTop: "8px",
  },
  skillsWrapper: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "12px",
    justifyContent: "center",
  },
  skillButton: {
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};

export default ServicesSection;